import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import ZnizkiService from "./ZnizkiService";
import ZnizkiTable from "./components/ZnizkiTable";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import {TopButtonAdd} from "../../../../componentsTopsa/buttons/TopButtons";
import ZnizkiForm from "./components/ZnizkiForm";
import ReactNotify from 'react-notify';
import TrasyService from "../../trasyConfig/trasy/TrasyService";
import utilitiesTopSelect from "../../../../utilities/utilitiesTopSelect";
import ScrollUtilities from "../../../../utilities/ScrollUtilities";

export default class ZnizkiContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            znizki: [],
            trasy: [],
            trasyTS: [],
            pokazFormularz: false,
            edytowana: null,
        };
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onClickZmienEsprzedaz = this.onClickZmienEsprzedaz.bind(this)
        this.onClickZmienUKierowcy = this.onClickZmienUKierowcy.bind(this)
        this.onClickZmienUoperatora = this.onClickZmienUoperatora.bind(this)
        this.zamknijFormularz = this.zamknijFormularz.bind(this)
    }

    componentDidMount() {
        this.pobierzZnizki()
        this.pobierzTrasy()
    }

    pobierzZnizki() {
        ZnizkiService.getZnizki().then(function (response) {
            this.setState({znizki: response.data.content})
        }.bind(this))
    }

    pobierzTrasy(){
        TrasyService.getTrasy().then(function (response) {
            this.setState({
                trasy:response.data.content,
                trasyTS: utilitiesTopSelect.changeTabOfObjectsToSimpleObject(response.data.content, "idTr", 'kodTrasy', 'nazTr', null)
            })
        }.bind(this))
    }

    zamknijFormularz() {
        this.setState({
            pokazFormularz: false,
            edytowana: null,
        })
    }

    onClickZapisz(obj, czyEdycja) {
        if(Boolean(czyEdycja)){
            ZnizkiService.editZnizka(this.state.edytowana.idZn,obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie edytowano zniżkę", "", 3000);
                    this.pobierzZnizki();
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas edycji zniżki ", "", 3000);
                }
            }.bind(this))
        }
        else{
            ZnizkiService.addZnizka(obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie dodano zniżkę", "", 3000);
                    this.pobierzZnizki();
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas dodawania zniżki ", "", 3000);
                }
            }.bind(this))
        }
        this.zamknijFormularz();
    }

    onClickEdytuj(obj) {
        ScrollUtilities.scrollToTop()
        this.setState({
            pokazFormularz: true,
            edytowana: obj,
        })
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc znizke: ' + obj.nazZniz)) {
              ZnizkiService.deleteZnizka(obj.idZn).then(function (response) {
                  if (response.status < 300) {
                      this.refs.notificator.success("Pomyślnie usunięto zniżkę", "", 3000);
                      this.pobierzZnizki();
                  }
                  else {
                      this.refs.notificator.error("Wystąpił błąd podczas usuwania zniżki ", "", 3000);
                  }
              }.bind(this))
        }
    }

    onClickZmienEsprzedaz(obj,czyEsprzedaz){
        let znizka = obj;
        znizka.esprzedaz = czyEsprzedaz;
        ZnizkiService.editZnizka(obj.idZn,obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success("Pomyślnie edytowano esprzedaz", "", 3000);
                this.pobierzZnizki();
            }
            else {
                this.refs.notificator.error("Wystąpił błąd podczas edycji esprzedazy ", "", 3000);
            }
        }.bind(this))
    }

    onClickZmienUKierowcy(obj,czyUKierowcy){
        let znizka = obj;
        znizka.ukierowcy = czyUKierowcy;
        ZnizkiService.editZnizka(obj.idZn,obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success("Pomyślnie edytowano status u kierowcy", "", 3000);
                this.pobierzZnizki();
            }
            else {
                this.refs.notificator.error("Wystąpił błąd podczas edycji statusu u kierowcy ", "", 3000);
            }
        }.bind(this))
    }

    onClickZmienUoperatora(obj,czyuoperatora){
        let znizka = obj;
        znizka.uoperatora = czyuoperatora;
        ZnizkiService.editZnizka(obj.idZn,obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success("Pomyślnie edytowano status u operatora", "", 3000);
                this.pobierzZnizki();
            }
            else {
                this.refs.notificator.error("Wystąpił błąd podczas edycji statusu u operatora ", "", 3000);
            }
        }.bind(this))
    }



    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'ZarzadzanieBiletamiContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-biletami',
                                    text: 'Zarządzanie biletami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-biletami/znizki', text: 'Zniżki'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <TopIf isTrue={!this.state.pokazFormularz}>
                                <div className={'pull-right'}>
                                    <TopButtonAdd onClick={() => {
                                        this.setState({pokazFormularz: true});
                                        ScrollUtilities.scrollToTop()
                                    }} text={'Dodaj zniżkę'} buttonSize={'small'}/>
                                </div>
                            </TopIf>
                        </Col>
                        <Col xs={12}>
                            <TopIf isTrue={this.state.pokazFormularz}>
                                <ZnizkiForm handleZapisz={this.onClickZapisz}
                                            edytowana={this.state.edytowana}
                                            handleAnuluj={this.zamknijFormularz}
                                            trasy={this.state.trasy}
                                />
                            </TopIf>
                        </Col>
                        <Col xs={12}>
                            <ZnizkiTable data={this.state.znizki}
                                         wlaczSzukanie={true}
                                         handleEdytuj={this.onClickEdytuj}
                                         handleUsun={this.onClickUsun}
                                         handleZmienEsprzedaz={this.onClickZmienEsprzedaz}
                                         handleZmienUKierowcy={this.onClickZmienUKierowcy}
                                         handleZmienuoperatora={this.onClickZmienUoperatora}
                                         trasy={this.state.trasy}
                                         trasyTS={this.state.trasyTS}
                            />
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/znizki/ZnizkiContainer.js